import * as React from 'react'
import { FC } from 'react'
import { cls } from '../../utils/utils'
import SvgIcon from '../SVGIcon/SvgIcon'
import * as styles from './DottedRectangles.module.scss'

export type DottedRectanglesColors = 'black' | 'grey' | 'white' | 'dark'

const DottedRectangles: FC<{ color: DottedRectanglesColors; className?: string }> = ({ color, className }) => (
  <div className={styles.block}>
    <SvgIcon href="/images/dotted-rectangles.svg#icon" className={cls(styles.rectangles, styles[color], className)} />
  </div>
)

export default DottedRectangles
